<script lang="ts">
  type TextColor =
    | 'secondary'
    | 'primary'
    | 'tertiary'
    | 'white'
    | 'highlightRed'
    | 'highlightBlue'
    | 'highlightGreen';
  type TextSize = 'large' | 'normal' | 'medium' | 'small' | 'extra-small';
  type TagName = 'div' | 'span' | 'caption' | 'p' | 'label' | 'legend';

  export let bold = false;
  export let className = '';
  export let color: TextColor = 'primary';
  export let tagName: TagName = 'p';
  export let size: TextSize = 'normal';
  export let underlined = false;
</script>

<svelte:element
  this={tagName}
  class="text color--{color} size--{size} {underlined ? 'underlined' : ''} {bold
    ? 'bold'
    : ''} {className}"
  {...$$restProps}
>
  <slot />
</svelte:element>

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/font-sizes';

  .text {
    font-family: MiloADAC, sans-serif;
    font-weight: normal;
  }

  .bold {
    font-weight: bold;
  }

  .underlined {
    text-decoration: underline;
  }

  .color--primary {
    color: colors.$black90;
  }

  .color--secondary {
    color: colors.$black60;
  }

  .color--tertiary {
    color: colors.$black40;
  }

  .color--white {
    color: colors.$white100;
  }

  .color--highlightRed {
    color: colors.$highlightRed;
  }

  .color--highlightBlue {
    color: colors.$highlightBlue;
  }

  .color--highlightGreen {
    color: colors.$highlightGreen;
  }

  .size--extra-small {
    font-size: font-sizes.$text-xs;
    line-height: 1.33;
  }

  .size--small {
    font-size: font-sizes.$text-s;
    line-height: 1.43;
  }

  .size--medium {
    font-size: font-sizes.$text-m;
    line-height: 1.25;
  }

  .size--normal {
    font-size: font-sizes.$text-l;
    line-height: 1.33;
  }

  .size--large {
    font-size: font-sizes.$text-xl;
    line-height: 1.6;
  }
</style>
